module.exports = __webpack_public_path__ + "static/media/process_h5.a653c56d.png";